import { render, staticRenderFns } from "./MCriticalAudits.vue?vue&type=template&id=bf900380&lang=pug&"
import script from "./MCriticalAudits.vue?vue&type=script&lang=ts&"
export * from "./MCriticalAudits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports